import * as React from "react";
import styled, { css } from "styled-components";

import { Company, CompanyMembershipSection, User } from "../entities";
import withEntitiesFactory from "../../common/utils/withEntitiesFactory";
import { colors, truncateLines } from "../../common/utils/style";
import Translate from "../../common/components/Translate";
import Link from "../../common/components/router/Link";
import Hover from "../../common/components/Hover";
import { navFullPath } from "./HeaderNav";

import MembershipSectionCover from "../../company_memberships/components/MembershipSectionCover";

interface Props {
  className?: string;
  section: CompanyMembershipSection;
  company: Company;
  floatsByHover?: boolean;
}

const WithUserEntities = withEntitiesFactory<{
  coverMembers: User[];
}>({ coverMembers: "users" }, "companies");

class MembershipTeamCard extends React.PureComponent<Props> {
  public render() {
    const { section } = this.props;
    return (
      <WithUserEntities
        selector={{
          coverMembers: section.cover_members,
        }}
      >
        {({ coverMembers }) => this.renderWithEntities(coverMembers)}
      </WithUserEntities>
    );
  }

  private renderWithEntities(coverMembers?: User[]) {
    const { section, company, floatsByHover, className } = this.props;
    return (
      <Hover>
        {({ isHovered, ref }) => (
          <Base innerRef={ref} isHovered={Boolean(floatsByHover) && isHovered} className={className}>
            <WrapperLink to={navFullPath(company, `/members#${section.name}`)}>
              <MembershipSectionCoverWrapper>
                <MembershipSectionCover members={coverMembers || []} />
              </MembershipSectionCoverWrapper>
              <MemberSectionMeta>
                <MemberSectionName>{section.name}</MemberSectionName>
                <MemberSectionMemberInfo>
                  {coverMembers &&
                    coverMembers[0] && (
                      <div>
                        <Translate
                          id="company.members.section_representative_name"
                          values={{ name: coverMembers[0].name }}
                        />
                      </div>
                    )}
                  {section.members_count > 1 && (
                    <RestCount>
                      <Translate
                        id="company.members.section_rest_count_of_members"
                        values={{ count: section.members_count - 1 }}
                      />
                    </RestCount>
                  )}
                </MemberSectionMemberInfo>
              </MemberSectionMeta>
            </WrapperLink>
          </Base>
        )}
      </Hover>
    );
  }
}

interface StyleProps {
  isHovered: boolean;
}

const Base = styled.div`
  height: 282px;
  box-sizing: border-box;
  border-radius: 4px;
  border: solid 1px #eeeeee;
  background-color: #ffffff;
  transform: translateY(0);
  transition: transform 200ms ease-out, box-shadow 200ms ease-out;
  margin-bottom: 20px;
  ${(props: StyleProps) =>
    props.isHovered
      ? css`
          transform: translateY(-5px);
          box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.1);
        `
      : ""};
`;

const WrapperLink = styled(Link)`
  display: block;
  &:hover {
    text-decoration: none;
  }
`;

const MembershipSectionCoverWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 160px;
`;

const MemberSectionMeta = styled.div`
  padding: 14px 12px;
`;

const MemberSectionName = styled.div`
  height: 44px;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.47;
  ${truncateLines(2, 15, 1.47)};
  color: ${colors.gray4};
  margin-bottom: 14px;
`;

const MemberSectionMemberInfo = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.gray1};
`;

const RestCount = styled.div`
  font-weight: 600;
`;

export default MembershipTeamCard;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/MembershipTeamCard.tsx